<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  <app-uploader
    [control]="formControl"
    [label]="props.label"
    [tooltip]="props.tooltip"
    [description]="props.description"
    [multiple]="props.multiple"
    [tag]="props?.tag"
    [maxSize]="props?.validations?.max"
    [maxCount]="props?.validations?.count"
    [extensionsAccepted]="props?.availableExtensions"
    [fileableType]="props?.fileableType"
    [messages]="props?.messages">
  </app-uploader>
</div>
